import store from '@/store'
import { getIntegratorId } from '@/composables/currentUser'
import { computed } from 'vue'

export default function useIntegrator() {
  const integrator = computed(() => store.getters['info/integrator'])
  const integratorsForDropdown = computed(() => store.getters['info/integratorsForDropdown'])

  const getCurrentIntegrator = async () => {
    const integratorId = getIntegratorId()
    if (integratorId) {
      return await getIntegratorById(integratorId)
    }
  }
  const getIntegratorById = async integratorId => await store.dispatch('info/getIntegrator', integratorId)
  const fetchIntegratorsForDropdown = async () => {
    if (!integratorsForDropdown.value.length) {
      await store.dispatch('info/fetchIntegratorsForDropdown')
    }
  }

  return {
    integrator,
    integratorsForDropdown,

    getCurrentIntegrator,
    fetchIntegratorsForDropdown,
  }
}